import { gql } from '@common/hooks';

export const WorksMembershipsQuery = gql`
  query WorksMembershipsQuery($input: WorksMembershipInput!) {
    worksMemberships(input: $input) {
      collection {
        id
        firstName
        lastName
        roleName
        role
        email
        employeeId
        organizationBusinessesCount
        organizationUnitsCount
        updatedAt
        active
        canUserUpdateMembership
      }
      metadata {
        totalCount
      }
    }
  }
`;

export type WorksMembershipsResponse = {
  worksMemberships: {
    collection: Membership[];
    metadata: {
      totalCount: number;
    };
  };
};

export type Membership = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  employeeId: string;
  roleName: string;
  role: string;
  organizationBusinessesCount: number;
  organizationUnitsCount: number;
  updatedAt: string;
  active: boolean;
  canUserUpdateMembership: boolean;
};
